export default __webpack_public_path__ + "static/media/desk-break-mobility.f0598376.jpg";